/*
 * Copyright (c) 2018 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import {
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent,
} from '@angular/common/http';
import { SKIP_UI_BLOCKER } from '@irian-ro/abstract-resource';
import { Observable, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable()
export class UiBlockerHttpInterceptor implements HttpInterceptor {
  static readonly blockUi: Subject<boolean> = new Subject();
  private emitNumber = 0;

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<unknown> | HttpUserEvent<unknown>> {
    const newReq = req.clone();

    if (newReq.context.get(SKIP_UI_BLOCKER)) {
      return next.handle(newReq);
    }

    if (['PATCH', 'PUT', 'POST', 'DELETE'].includes(newReq.method)) {
      if (newReq.url.includes('/administration/api/exceptions')) {
        return next.handle(newReq);
      }

      this.emitNumber++;
      if (this.emitNumber > 0) {
        UiBlockerHttpInterceptor.blockUi.next(true);
      }

      return next.handle(newReq).pipe(
        finalize(() => {
          this.emitNumber--;
          if (this.emitNumber <= 0) {
            UiBlockerHttpInterceptor.blockUi.next(false);
          }
        })
      );
    }

    return next.handle(newReq);
  }
}
